import { getTelemetryAttributes } from "@msdyn365-commerce-modules/utilities";
import { Dropdown, IDropdownItemProps, IDropdownProps } from "@msdyn365-commerce/components";
import React from "react";

export class ProductConfigurationDropdown extends Dropdown {
    public constructor(props: IDropdownProps) {
        super(props);
    }

    public render(): JSX.Element {
        // ADA - aria_attribute_valid - The ARIA attributes \"aria-selected\" are not valid for the element <option> with implicit ARIA role \"option\"
        const { dropdownId, dropdownList, dropdownName, dropdownToggleName } = this.props;
        const attribute = getTelemetryAttributes(this.props.telemetryContent!, (this as any).payLoad);
        return (
            <select
                id={`msc-dropdown__entry-${dropdownId}`}
                ref={(this as any).selectMenu}
                aria-label={dropdownName}
                className='msc-dropdown__select'
                onChange={(this as any)._onChanged}
                {...attribute}
            >
                <option value='' selected={this.state.selectedIndex === ''} hidden disabled>
                    {dropdownToggleName}
                </option>
                {dropdownList.map((item: IDropdownItemProps) => (
                    <option
                        value={item.id}
                        key={item.id}
                        selected={this.state.selectedIndex === item.id.toString()}
                        className={item.isDisabled ? 'msc-dropdown__select__disabled' : undefined}
                    >
                        {item.value}
                    </option>
                ))}
            </select>
        );
    }
}